<template lang="html">

  <div class="wrapper -como-inscribirte">

    <section class="intro -como-inscribirte column-center" :style="`background:url(${$t('Imagen como inscribirse')}) center/cover no-repeat`">

      <h1 class="big-title mt0 column-center">
        <span>{{$t('Titulo como inscribirse')}}</span>
        <span>{{$t('Subtitulo como inscribirse')}}</span>
      </h1>

    </section>


    <section class="breadcrumb">
      <nav class="container row-start">
        <router-link to="/">Home</router-link>
        <router-link :to="$t('enlaces.como_inscribirte')">Como inscribirte</router-link>
      </nav>
    </section>


    <section class="como-inscribirte-text">

      <h2>
        {{$t('Como inscribirse titulo')}}
      </h2>

      <div class="inscripcion-tips container">


        <article class="tip-el row-start">
          <div class="numero"><span>1</span><img :src="$t('Tip inscribirse 1 imagen')" alt="Inscribirse"></div>
          <div class="contenedor-texto">
            <h3>{{$t('Tip inscribirse 1 titulo')}}</h3>
            <p>{{$t('Tip inscribirse 1 cuerpo')}}</p>
            <ul>
              <li>
                <img :src="$t('Tip inscribirse 1 telefono imagen')" alt="Telefono">
                <p v-html="$t('Tip inscribirse 1 telefono texto')"></p>
              </li>
              <li>
                <img :src="$t('Tip inscribirse 1 web imagen')" alt="Web">
                <p v-html="$t('Tip inscribirse 1 web texto')"></p>
              </li>
              <li>
                <img :src="$t('Tip inscribirse 1 alojamiento imagen')" alt="alojamiento">
                <p v-html="$t('Tip inscribirse 1 alojamiento texto')"></p>
              </li>
            </ul>
          </div>
        </article>
        <article class="tip-el row-start">
          <div class="numero"><span>2</span><img :src="$t('Tip inscribirse 2 imagen')" alt="inscribirse"></div>
          <div class="contenedor-texto">
            <h3>{{$t('Tip inscribirse 2 titulo')}}</h3>
            <p>{{$t('Tip inscribirse 2 cuerpo')}}</p>
          </div>
        </article>
        <article class="tip-el row-start">
          <div class="numero"><span>3</span><img :src="$t('Tip inscribirse 3 imagen')" alt="tip para inscribirse"></div>
          <div class="contenedor-texto">
            <h3>{{$t('Tip inscribirse 3 titulo')}}</h3>
          </div>
        </article>

        <p class="explain">{{$t('Tips inscribirse ayuda')}}</p>


      </div>


    </section>


  </div>

</template>

<script lang="js">


  export default {
    name: 'vivir-experiencias',
    components: {
    }
  }

</script>


<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/views/como-inscribirte.vue